import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { userProfileReducer } from '../../nowaccount/reducers+selectors/user-profile.reducers';
import { accountManagerContactReducer } from '../../onboarding/reducers+selectors/account-manager-contact.reducer';
import { businessProfileReducer } from '../../onboarding/reducers+selectors/business-profile.reducer';
import { createAccountReducer } from '../../onboarding/reducers+selectors/create-account.reducer';
import { customerPortfolioReducer } from '../../onboarding/reducers+selectors/customer-portfolio.reducer';
import { createEnrollmentReducer } from '../../onboarding/reducers+selectors/enrollment.reducer';
import { financialProfileReducer } from '../../onboarding/reducers+selectors/financial-profile.reducer';
import { clearMetaReducer } from './clear.meta-reducer';
import { hydrationStatusReducer } from './hydration-status.reducer';
import { hydrationMetaReducer } from './hydration.meta-reducer';

export const metaReducers: MetaReducer[] = [
  hydrationMetaReducer,
  clearMetaReducer,
];

export const reducers: ActionReducerMap<any> = {
  accountManagerContact: accountManagerContactReducer,
  enrollment: createEnrollmentReducer,
  createAccount: createAccountReducer,
  businessProfile: businessProfileReducer,
  financialProfile: financialProfileReducer,
  customerPortfolio: customerPortfolioReducer,
  hydrationStatus: hydrationStatusReducer,
  userProfile: userProfileReducer,
};
